import { useEffect } from 'react';
import { Form, Card } from 'react-bootstrap';
import { validateEmail, validatePhone, formatPhoneInput } from '../../helpers/FormInputsHelper';
import languageManager from '../../helpers/Language';

const InviteUserInformation = ({
    userAccessType,
    userInformation,
    setUserInformation,
    onAccessTypeChange,
    setIsFormValid,
}) => {
    const accessTypeMap = {
        REGULAR: 'regular_user',
        BUSINESS_OWNER: 'business_owner'
    };

    useEffect(() => {
        setIsFormValid(
            userAccessType === accessTypeMap.REGULAR &&
            validatePhone(userInformation.phone) &&
            validateEmail(userInformation.email)
        );
    }, [userInformation, userAccessType]);

    const onChange = (event) => {
        let { name, value } = event.target;

        if (name === 'phone') {
            value = formatPhoneInput(value);
        }

        setUserInformation({
            ...userInformation,
            [name]: value
        });
    };

    return (
        <>
            <Card className="shadow-sm">
                <Card.Body>
                    <Form.Group className="mb-3" controlId="userAccessType.ci1">
                        <Form.Label className="fw-bold">
                            {languageManager.T('GEN_LABEL_ACCESS_TYPE')}
                            <span style={{color: "red"}}> *</span>
                        </Form.Label>
                        <Form.Check
                            id={accessTypeMap.BUSINESS_OWNER}
                            onChange={onAccessTypeChange}
                            type="checkbox"
                            value={accessTypeMap.BUSINESS_OWNER}
                            label={languageManager.T('GEN_LABEL_USER_ROLE_BUSINES_OWNER')}
                            checked={userAccessType === accessTypeMap.BUSINESS_OWNER}
                        />
                        <Form.Check
                            id={accessTypeMap.REGULAR}
                            onChange={onAccessTypeChange}
                            type="checkbox"
                            value={accessTypeMap.REGULAR}
                            label={languageManager.T('GEN_LABEL_USER_ROLE_REGULAR')}
                            checked={userAccessType === accessTypeMap.REGULAR}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="email.ci1">
                        <Form.Label className="fw-bold">
                            {languageManager.T('GEN_LABEL_EMAIL_ADDRESS')}
                            <span style={{color: "red"}}> *</span>
                        </Form.Label>
                        <Form.Control
                            name='email'
                            type="email"
                            placeholder="user_email@example.com"
                            value={userInformation.email}
                            onChange={onChange}
                            required
                            isInvalid={!validateEmail(userInformation.email) && userInformation.email !== ''}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter a valid email format. 
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="firstname.ci1">
                        <Form.Label className= "fw-bold">{languageManager.T('GEN_LABEL_FIRST_NAME')}</Form.Label>
                        <Form.Control
                            name='firstname'
                            type='text'
                            value={userInformation.firstname}
                            onChange={onChange}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="lastname.ci1">
                        <Form.Label className= "fw-bold">{languageManager.T('GEN_LABEL_LAST_NAME')}</Form.Label>
                        <Form.Control
                            name='lastname'
                            type='text'
                            value={userInformation.lastname}
                            onChange={onChange}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="phone.ci1">
                        <Form.Label className= "fw-bold">{languageManager.T('GEN_LABEL_PHONE')}</Form.Label>
                        <Form.Control
                            name='phone'
                            type='text'
                            value={userInformation.phone}
                            placeholder="(xxx) xxx-xxxx"
                            onChange={onChange}
                            isInvalid={!validatePhone(userInformation.phone)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter a valid phone format or leave this field blank.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Card.Body>
            </Card>
            
        </>
    );
}

export default InviteUserInformation;
